<mat-nav-list class="main-nav-list">
  <div class="main-nav-list__top">
    <a mat-list-item class="toggle-menu" data-cy="toggle-sidenav-button" (click)="toggleSidenavPinned()">
      <!-- Initial state icon -->
      @if (sidenavPinned() === false) {
        <mat-icon class="menuTrigger menuTrigger--default" svgIcon="menu" />
      }

      <!-- Show on menu hover -->
      @if (sidenavPinned() === false) {
        <mat-icon class="menuTrigger menuTrigger--expand" svgIcon="chevron-double-right" matTooltip="Expand" />
      }

      <!-- Show when menu is pinned -->
      @if (sidenavPinned()) {
        <mat-icon class="menuTrigger menuTrigger--collapse" svgIcon="chevron-double-left" matTooltip="Collapse" />
      }
      <span matLine class="toggle-menu__text">Navigation</span>
    </a>

    @if (loading()) {
      <div>
        @for (_ of menuItems(); track $index) {
          <app-menu-list-loader />
        }
      </div>
    }

    <div [hidden]="projectSetupLoaded() === false">
      @for (item of menuItems(); track $index) {
        @if (item.hasAccess) {
          <a
            mat-list-item
            [ngClass]="{ 'active': item.link === activeRoute() }"
            [attr.data-cy]="`${item.link}-sidenav-link`"
            (click)="navigateToItem(item.link)">
            <mat-icon
              matTooltipPosition="right"
              [svgIcon]="item.icon"
              [matTooltip]="item.label"
              [matTooltipDisabled]="sidenavPinned()" />
            <span matLine class="toggle-menu__text">{{ item.label }}</span>
          </a>
        }
      }
    </div>
  </div>

  @if (canShowSupport()) {
    <a
      #supportToggle
      mat-list-item
      class="support-toggle"
      data-cy="support-sidenav-button"
      [ngClass]="{ 'active': isSupportOpen() }"
      (click)="toggleSupport($event)">
      <mat-icon
        class="sidebar-support"
        matTooltipPosition="right"
        svgIcon="message-text"
        matTooltip="Support"
        matBadgeSize="small"
        [matTooltipDisabled]="sidenavPinned()"
        [matBadge]="supportUnreadCount()"
        [matBadgeHidden]="!supportUnreadCount()" />
      <span matLine class="toggle-menu__text">Support</span>
    </a>
  }
</mat-nav-list>
